import { categories } from './ccm';
import {
  EnvironmentTool,
  FieldMapping,
  MatchboiError,
  SupportedTools,
} from './interfaces';
import { toolFactory } from './tools';

const categoryNames = Object.keys(categories);

/* Generate final content using customer map and cyborg content template */
export const generateContent = (
  template: string,
  toolName: SupportedTools,
  contentCategories: Array<string>,
  envTool?: EnvironmentTool,
): Array<{ query: string; category: string; name?: string }> => {
  // check if any given category not in CCM
  if (contentCategories.length === 0) {
    throw new MatchboiError('Must provide at least one contentCategories item');
  }
  for (const category of contentCategories) {
    if (!categoryNames.includes(category)) {
      throw new MatchboiError(
        `Category "${category}" not found in CCM categories`,
      );
    }
  }

  // Get requested platform instance
  const tool = toolFactory(toolName);

  function groupBy(key) {
    return function group(array) {
      return array.reduce((acc, obj) => {
        const property = obj[key];
        acc[property] = acc[property] || [];
        acc[property].push(obj);
        return acc;
      }, {});
    };
  }

  const groupByCategory = groupBy('category');
  let grouped: { [key: string]: Array<FieldMapping> };

  if (envTool) grouped = groupByCategory(envTool?.fieldMappings);

  if (envTool && envTool.product == toolName) {
    return contentCategories
      .map((category) => {
        if (category in grouped) {
          return grouped[category].map((fieldMapping) => {
            return {
              query: tool.renderContentTemplatefromFieldMapping(
                template,
                fieldMapping,
              ),
              category: category,
              name: fieldMapping.name,
            };
          });
        } else {
          return {
            query: tool.renderContentTemplatefromFieldMapping(template),
            category: category,
          };
        }
      })
      .flat();
  } else {
    return contentCategories
      .map((category) => {
        return {
          query: tool.renderContentTemplatefromFieldMapping(template),
          category: category,
        };
      })
      .flat();
  }
};
